import { getAxiosInstance, requestConfig } from "../../http-common";
import { UpsertPermission } from "../../models/permissions/UpsertPermission";

const RESOURCE_NAME = "permissions";

const get = (id: number = null, userId: number = null, groupId: number = null) => {
    const http = getAxiosInstance();
    
    if (id !== null) {
        return http.get(`${RESOURCE_NAME}?id=${id}`, requestConfig());
    } else if (userId !== null) {
        return http.get(`${RESOURCE_NAME}?userId=${userId}`, requestConfig());
    } else if (groupId !== null) {
        return http.get(`${RESOURCE_NAME}?groupId=${groupId}`, requestConfig());
    }
};

const upsert = (model: UpsertPermission[]) => {
    const http = getAxiosInstance();
    return http.put(`${RESOURCE_NAME}`, model, requestConfig());
};

const PermissionsService = {
    get,
    upsert,
};
export default PermissionsService;
